import { render, staticRenderFns } from "./Contactus.vue?vue&type=template&id=01e8ab14&scoped=true"
import script from "./Contactus.vue?vue&type=script&lang=js"
export * from "./Contactus.vue?vue&type=script&lang=js"
import style0 from "./Contactus.vue?vue&type=style&index=0&id=01e8ab14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e8ab14",
  null
  
)

export default component.exports